export default __webpack_public_path__ + "static/teaBag3-996523044592f2b7c79d9d33e2e25456.png";